export function mapProjectIdStringToPublisherProjectId(projectId?: string): string {
    if (!projectId)
        return '4';

    switch (projectId.toLocaleLowerCase()) {
        case 'ppk':
        case 'ppf':
        case 'pingpongfury':
        case 'ping-pong-fury':
        case '1':
            return '1';

        case 'ppfo':
        case '3':
            return '3';

        case 'dof':
        case 'darts':
        case 'dartsoffury':
        case 'darts-of-fury':
        case '4':
            return '4';

        case 'ykt-bowl':
        case '5':
            return '5';

        default:
            return '4';
    }
}

export function mapPublisherProjectIdToProjectIdString(projectId?: string): string {

    if (!projectId)
        return '';

    switch (projectId.toLocaleLowerCase()) {
        case '1':
        case 'ppf':
        case 'ppk':
            return 'ppf';

        case '3':
        case 'ppfo':
            return 'ppfo';

        case '4':
        case 'dof':
            return 'dof';

        case '5':
        case 'ykt-bowl':
            return 'ykt-bowl';

        case 'prototype':
            return 'prototype';

        default:
            return '';
    }
}
